/**
 * Automation Who Section
 *
 * Edit mode UI for configuring WHO the automation applies to.
 * Used inline within AutomationCard when editing the "Who" section.
 */

import { useFormikContext } from 'formik';
import { FC } from 'react';
import { Box } from 'src/components/Box';

import { AutomationFilters } from '../AutomationFilters';
import { AutomationItem } from '../types';

interface AutomationWhoSectionProps {
  automation: AutomationItem;
  index: number;
}

export const AutomationWhoSection: FC<AutomationWhoSectionProps> = ({
  automation,
  index,
}) => {
  const { setFieldValue } = useFormikContext();

  return (
    <Box>
      <AutomationFilters
        value={automation.filters}
        onChange={(filters) => {
          setFieldValue(`automations.${index}.filters`, filters);
        }}
      />
    </Box>
  );
};
